import { Button, Grid, MenuItem, TextField } from "@mui/material";
import styles from "./styles.module.css";
import InputMask from "react-input-mask";
import { useEffect, useState } from "react";
import { retornarEnderecoPeloCep } from "../../../services/address.service";
import { validarFormatacaoDocumento } from "../../../services/validation.service";

const DadosTitular = ({
  handleStep,
  dataForm,
  setDataForm,
  setMsg,
  setOpenSnackbarErro,
  error,
  setError,
  handleError,
  handleHelperText,
  cidade,
  setCidade,
}) => {
  const [documentoValido, setDocumentoValido] = useState(false);

  const tipoDoc = [
    {
      value: "cpf",
      label: "CPF",
    },
    {
      value: "cnpj",
      label: "CNPJ",
    },
  ];

  useEffect(() => {
    if (dataForm?.dadosTitular?.cpf || dataForm?.dadosTitular?.cnpj) {
      setDocumentoValido(true);
    }
  }, []);

  useEffect(() => {
    const cep = (dataForm?.dadosTitular?.cep).replace("-", "");
    const apiCep = async () => {
      try {
        const response = await retornarEnderecoPeloCep(cep);
        if (response?.erro) {
          setMsg("CEP não encontrado!");
          setOpenSnackbarErro(true);
        } else {
          setDataForm({
            ...dataForm,
            dadosTitular: {
              ...dataForm.dadosTitular,
              logradouro: response.logradouro,
              bairro: response.bairro,
              cidade: response.ibge,
              estado: response.uf,
              pais: "Brasil",
            },
          });
          setCidade(response.localidade);
        }
      } catch (error) {
        console.log(error);
      }
    };
    if (cep.length === 8) {
      apiCep();
    } else {
      setDataForm({
        ...dataForm,
        dadosTitular: {
          ...dataForm.dadosTitular,
          logradouro: "",
          bairro: "",
          cidade: "",
          estado: "",
          pais: "",
        },
      });
      setCidade("");
    }
  }, [dataForm?.dadosTitular?.cep]);

  useEffect(() => {
    const documento =
      dataForm?.dadosTitular?.tipoDocumento === "cpf"
        ? dataForm?.dadosTitular?.cpf
        : dataForm?.dadosTitular?.cnpj;
        
    const handleVerificarDocumento = async () => {
      const response = await validarFormatacaoDocumento(
        documento,
        dataForm?.dadosTitular?.tipoDocumento.toUpperCase()
      );
      if (!response) {
        setDocumentoValido(false);
        setMsg("Documento inválido!");
        setOpenSnackbarErro(true);
      } else {
        setDocumentoValido(true);
      }
    };

    if (documento?.length === 14) {
      handleVerificarDocumento();
    } else {
      setDocumentoValido(false);
    }
    if (documento?.length === 11) {
      handleVerificarDocumento();
    } else {
      setDocumentoValido(false);
    }
  }, [dataForm?.dadosTitular?.cpf, dataForm?.dadosTitular?.cnpj]);

  const handleNext = (e) => {
    e.preventDefault();
    const form = e.target;
    if (dataForm?.dadosTitular?.cpf && !documentoValido) {
      setMsg("CPF Inválido");
      setOpenSnackbarErro(true);
    }
    if (dataForm?.dadosTitular?.cnpj && !documentoValido) {
      setMsg("CNPJ Inválido");
      setOpenSnackbarErro(true);
    }
    if (form.checkValidity() && documentoValido) {
      handleStep(1);
    } else {
      setError(true);
    }
  };

  const handleChange = (e) => {
    const { name } = e.target;
    let value = e.target.value;

    switch (name) {
      case "cpf":
        {
          value = value.replace(/[^\w\s]/gi, "");
          setDataForm({
            ...dataForm,
            dadosTitular: { ...dataForm.dadosTitular, cpf: value, cnpj: "" },
          });
        }
        break;
      case "cnpj":
        {
          value = value.replace(/[^\w\s]/gi, "");
          setDataForm({
            ...dataForm,
            dadosTitular: { ...dataForm.dadosTitular, cnpj: value, cpf: "" },
          });
        }
        break;
      default:
        setDataForm({
          ...dataForm,
          dadosTitular: { ...dataForm.dadosTitular, [name]: value },
        });
        break;
    }
  };

  return (
    <form onSubmit={handleNext} noValidate>
      <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
        <Grid item xs={12} sm={4} md={4}>
          <TextField
            size="small"
            label="Nome"
            name="nome"
            fullWidth
            value={dataForm?.dadosTitular?.nome}
            onChange={handleChange}
            error={handleError("dadosTitular", "nome")}
            helperText={handleHelperText("dadosTitular", "nome")}
            required
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2}>
          <InputMask
            mask="99999-999"
            maskChar={null}
            value={dataForm?.dadosTitular?.cep}
            onChange={handleChange}
          >
            {() => (
              <TextField
                size="small"
                label="CEP"
                name="cep"
                fullWidth
                error={handleError("dadosTitular", "cep")}
                helperText={handleHelperText("dadosTitular", "cep")}
                required
              />
            )}
          </InputMask>
        </Grid>

        <Grid item xs={12} sm={5} md={6}>
          <TextField
            size="small"
            label="Logradouro"
            fullWidth
            value={dataForm?.dadosTitular?.logradouro}
            disabled={dataForm?.dadosTitular?.logradouro ? true : false}
          />
        </Grid>

        <Grid item xs={12} sm={3} md={3}>
          <TextField
            size="small"
            label="Bairro"
            fullWidth
            value={dataForm?.dadosTitular?.bairro}
            disabled={dataForm?.dadosTitular?.bairro ? true : false}
          />
        </Grid>
        <Grid item xs={6} sm={2}>
          <TextField
            size="small"
            label="Número"
            name="numero"
            fullWidth
            value={dataForm?.dadosTitular?.numero}
            onChange={handleChange}
            error={handleError("dadosTitular", "numero")}
            helperText={handleHelperText("dadosTitular", "numero")}
            required
          />
        </Grid>
        <Grid item xs={6} sm={2}>
          <TextField
            size="small"
            label="Complemento"
            name="complemento"
            fullWidth
            value={dataForm?.dadosTitular?.complemento}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={3} md={3}>
          <TextField
            size="small"
            label="Cidade"
            fullWidth
            value={cidade}
            disabled
          />
        </Grid>
        <Grid item xs={6} sm={2} md={1}>
          <TextField
            size="small"
            label="Estado"
            fullWidth
            value={dataForm?.dadosTitular?.estado}
            disabled
          />
        </Grid>
        <Grid item xs={6} sm={2} md={1}>
          <TextField
            size="small"
            label="Pais"
            fullWidth
            value={dataForm?.dadosTitular?.pais}
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2}>
          <TextField
            size="small"
            label="Tipo Documento"
            name="tipoDocumento"
            fullWidth
            value={dataForm?.dadosTitular?.tipoDocumento}
            onChange={handleChange}
            required
            disabled
            select
          >
            {tipoDoc.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={3} md={2}>
          <InputMask
            mask={
              dataForm?.dadosTitular?.tipoDocumento === "cnpj"
                ? "99.999.999/9999-99"
                : "999.999.999-99"
            }
            maskChar={null}
            value={
              dataForm?.dadosTitular?.tipoDocumento === "cpf"
                ? dataForm?.dadosTitular?.cpf
                : dataForm?.dadosTitular?.cnpj
            }
            onChange={handleChange}
          >
            {() => (
              <TextField
                size="small"
                label={dataForm?.dadosTitular?.tipoDocumento?.toUpperCase()}
                name={dataForm?.dadosTitular?.tipoDocumento}
                error={
                  error &&
                  (!documentoValido ||
                    dataForm?.dadosTitular?.cpf ||
                    dataForm?.dadosTitular?.cnpj)
                }
                helperText={handleHelperText(
                  "dadosTitular",
                  dataForm?.dadosTitular?.tipoDocumento
                )}
                color={
                  documentoValido &&
                  (dataForm?.dadosTitular?.cpf || dataForm?.dadosTitular?.cnpj)
                    ? "success"
                    : ""
                }
                fullWidth
                required
                InputProps={{
                  disabled: true
                }}
              />
            )}
          </InputMask>
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            size="small"
            label="E-mail"
            name="email"
            value={dataForm?.dadosTitular?.email}
            onChange={handleChange}
            error={handleError("dadosTitular", "email")}
            helperText={handleHelperText("dadosTitular", "email")}
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2}>
          <InputMask
            mask="(99) 9999 9999"
            maskChar={null}
            value={dataForm?.dadosTitular?.telefone}
            onChange={handleChange}
          >
            {() => (
              <TextField
                size="small"
                label="Telefone"
                name="telefone"
                fullWidth
              />
            )}
          </InputMask>
        </Grid>
        <Grid item xs={12} sm={3}>
          <InputMask
            mask="(99) 9 9999 9999"
            maskChar={null}
            value={dataForm?.dadosTitular?.whatsapp}
            onChange={handleChange}
          >
            {() => (
              <TextField
                size="small"
                label="WhatsApp"
                fullWidth
                name="whatsapp"
                error={handleError("dadosTitular", "whatsapp")}
                helperText={handleHelperText("dadosTitular", "whatsapp")}
                required
              />
            )}
          </InputMask>
        </Grid>
      </Grid>

      <div className={styles.container_button}>
        <Button className={styles.button_next} type="submit">
          Avançar
        </Button>
      </div>
    </form>
  );
};

export default DadosTitular;
